import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './PedidoPagado.css';
import baseURL from '../url';

const PedidoPagado = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // Obtenemos el ID del parámetro GET
    const [cargando, setCargando] = useState(true);
    const [datosPedido, setDatosPedido] = useState(null);

    const cargarPedido = async () => {
        return fetch(`${baseURL}/api/admin/pedidos/pagados?gatewayTransactionId=${id}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const pedido = {
                    ...data.pedido,
                    productos: JSON.parse(data.pedido.productos)
                }
                setDatosPedido(pedido);
                return data;
            })
            .catch(error => console.error('Error al cargar pedido:', error));
    };

    useEffect(() => {
        // Simular carga de datos desde una API
        const timer = setTimeout(() => {
            if (id) {
                // setDatosPedido({ ...datosSimulados, id });
                cargarPedido();
            }
            setCargando(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, [id]);

    if (cargando) {
        return (
            <div className="pedido-pagado-container">
                <div className="pedido-pagado-card">
                    <div className="pedido-pagado-loading">
                        <div className="pedido-pagado-spinner"></div>
                        <p>Cargando información del pedido...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!datosPedido) {
        return (
            <div className="pedido-pagado-container">
                <div className="pedido-pagado-card">
                    <div className="pedido-pagado-error">
                        <h2>Pedido no encontrado</h2>
                        <p>No se pudo encontrar la información del pedido.</p>
                        <Link to="/" className="pedido-pagado-btn pedido-pagado-btn-primario">
                            Volver al Inicio
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="pedido-pagado-container">
            <div className="pedido-pagado-card">
                {/* Icono de confirmación */}
                <div className="pedido-pagado-icono-confirmacion">
                    <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                            fill="#4CAF50"
                        />
                    </svg>
                </div>

                {/* Mensaje principal */}
                <h1 className="pedido-pagado-titulo-confirmacion">¡Pago Confirmado!</h1>

                <p className="pedido-pagado-mensaje-principal">
                    Tu pedido ha sido procesado exitosamente y el pago ha sido confirmado.
                </p>

                {/* Información del pedido */}
                <div className="pedido-pagado-info-pedido">
                    <div className="pedido-pagado-info-item">
                        <span className="pedido-pagado-info-label">ID de Transacción:</span>
                        <span className="pedido-pagado-info-valor">{id}</span>
                    </div>

                    <div className="pedido-pagado-info-item">
                        <span className="pedido-pagado-info-label">Número de pedido:</span>
                        <span className="pedido-pagado-info-valor">{datosPedido.idPedido}</span>
                    </div>

                    <div className="pedido-pagado-info-item">
                        <span className="pedido-pagado-info-label">Fecha de pedido:</span>
                        <span className="pedido-pagado-info-valor">{datosPedido.createdAt}</span>
                    </div>

                    <div className="pedido-pagado-info-item">
                        <span className="pedido-pagado-info-label">Cliente:</span>
                        <span className="pedido-pagado-info-valor">{datosPedido.nombre}</span>
                    </div>
                    <div className="pedido-pagado-info-item">
                        <span className="pedido-pagado-info-label">Correo de cliente:</span>
                        <span className="pedido-pagado-info-valor">{datosPedido.email}</span>
                    </div>
                </div>

                {/* Productos */}
                <div className="pedido-pagado-seccion">
                    <h3 className="pedido-pagado-subtitulo">Productos</h3>
                    {datosPedido.productos.map((producto, index) => (
                        <div key={index} className="pedido-pagado-producto">
                            <span className="pedido-pagado-producto-nombre">{producto.titulo}</span>
                            <span className="pedido-pagado-producto-detalle">
                                {producto.cantidad} x ${producto.precio.toFixed(2)}
                            </span>
                        </div>
                    ))}
                    <div className="pedido-pagado-total">
                        <span className="pedido-pagado-total-label">Total con envío:</span>
                        <span className="pedido-pagado-total-monto">${Number(datosPedido.total).toFixed(2)}</span>
                    </div>
                </div>


                {/* Mensaje de envío */}
                <div className="pedido-pagado-mensaje-envio">
                    <div className="pedido-pagado-icono-envio">🚚</div>
                    <p className="pedido-pagado-texto-envio">
                        Tu pedido está siendo preparado y será enviado pronto.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default PedidoPagado;